import { useState } from "react";
import { motion } from "framer-motion";
import { Mail, ArrowRight } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterSignupSection = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email: email.trim() });
      toast.success("Erfolgreich angemeldet!");
      setEmail("");
    } catch (err) {
      console.error(err);
      toast.error("Anmeldung fehlgeschlagen");
    }
    setLoading(false);
  };

  return (
    <section className="py-20 px-6 bg-lab-accent" data-testid="newsletter-signup-section">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row md:items-center md:justify-between gap-10"
        >
          <div className="md:max-w-lg">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-lab-primary/10 flex items-center justify-center">
                <Mail className="w-5 h-5 text-lab-primary" />
              </div>
              <span className="text-lab-primary text-sm font-semibold tracking-widest uppercase">Newsletter</span>
            </div>
            <h2 className="font-playfair text-2xl lg:text-3xl font-semibold text-lab-primary">
              Bleiben Sie informiert
            </h2>
            <p className="text-lab-primary/70 mt-3">
              Erhalten Sie monatlich Insights zu Digitalisierung, KI und Prozessoptimierung direkt in Ihr Postfach.
            </p>
          </div>

          <div className="flex-1 md:max-w-md">
            <form onSubmit={handleSubmit} className="flex" data-testid="newsletter-signup-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Ihre E-Mail-Adresse"
                required
                className="flex-1 px-5 py-4 bg-white border-0 text-lab-primary placeholder:text-lab-text-muted text-sm focus:outline-none focus:ring-2 focus:ring-lab-primary"
                data-testid="newsletter-signup-email"
              />
              <button
                type="submit"
                disabled={loading}
                className="bg-lab-primary text-white px-6 py-4 text-sm font-semibold hover:bg-lab-primary/90 transition-colors flex items-center gap-2 whitespace-nowrap disabled:opacity-50"
                data-testid="newsletter-signup-submit"
              >
                {loading ? "..." : "Anmelden"} <ArrowRight className="w-4 h-4" />
              </button>
            </form>
            <p className="text-lab-primary/50 text-xs mt-3">
              Kein Spam. Jederzeit abmeldbar. Datenschutz wird respektiert.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default NewsletterSignupSection;
